import * as i0 from '@angular/core';
import { inject, ElementRef, Renderer2, signal, input, computed, effect, afterNextRender, Directive } from '@angular/core';
function isDefined(value) {
  return value !== undefined && value !== null;
}
function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
class NgOptionHighlightDirective {
  constructor() {
    // Dependencies
    this.element = inject(ElementRef).nativeElement;
    this.renderer = inject(Renderer2);
    // Signals
    this.label = signal('', ...(ngDevMode ? [{
      debugName: "label"
    }] : []));
    // Inputs
    this.term = input('', ...(ngDevMode ? [{
      debugName: "term",
      alias: 'ngOptionHighlight'
    }] : [{
      alias: 'ngOptionHighlight'
    }]));
    // Computed properties
    this.canHighlight = computed(() => isDefined(this.term()) && isDefined(this.label()) && this.label() !== '', ...(ngDevMode ? [{
      debugName: "canHighlight"
    }] : []));
    // Update innerHTML using effect
    this._effectUpdateInnerHtml = effect(() => {
      if (!this.canHighlight()) {
        return;
      }
      this._highlightLabel();
    }, ...(ngDevMode ? [{
      debugName: "_effectUpdateInnerHtml"
    }] : []));
    this._ = afterNextRender(() => {
      this.label.set(this.element.innerHTML);
      // 1st label highlight triggers from here
      this._highlightLabel();
    });
  }
  _highlightLabel() {
    const label = this.label();
    if (!this.term()) {
      this._setInnerHtml(label);
      return;
    }
    const alternationString = escapeRegExp(this.term()).replace(' ', '|');
    const termRegex = new RegExp(alternationString, 'gi');
    this._setInnerHtml(label.replace(termRegex, `<span class=\"highlighted\">$&</span>`));
  }
  _setInnerHtml(html) {
    this.renderer.setProperty(this.element, 'innerHTML', html);
  }
  static {
    this.ɵfac = function NgOptionHighlightDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgOptionHighlightDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NgOptionHighlightDirective,
      selectors: [["", "ngOptionHighlight", ""]],
      inputs: {
        term: [1, "ngOptionHighlight", "term"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgOptionHighlightDirective, [{
    type: Directive,
    args: [{
      selector: '[ngOptionHighlight]',
      standalone: true
    }]
  }], null, {
    term: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "ngOptionHighlight",
        required: false
      }]
    }]
  });
})();

/*
 * Public API Surface of ng-option-highlight
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgOptionHighlightDirective };
